import { render, screen } from "@testing-library/react";
import Image from "./Image";

test("check rendering image", () => {
  render(<Image alt="img-alt" title="Sample title" />);
  expect(screen.getByAltText("img-alt")).toBeInTheDocument();
});
